// extracted by mini-css-extract-plugin
export var actions = "_tf-4";
export var item = "_tf-1";
export var price = "_tf-3";
export var quantity = "_tf-2";
export var table = "_tf-0";